import FlowSimpleBuilderv2 from "./FlowBuilderv2";

export default FlowSimpleBuilderv2;
